<template>
  <md-toolbar class="md-layout">
    <md-icon class="md-layout-item md-size-20">{{ icon }}</md-icon>
    <h4 class="md-layout-item md-size-80">{{ title }}</h4>
  </md-toolbar>
</template>

<script>
export default {

  name: 'TitleToolbar',

  props: {
  	icon: String,
  	title: String
  },

  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TitleToolbar.vue